export const layerStyles = {
	fillSpaceAbsolute: {
		width: "100%",
		height: "100%",
		position: "absolute",
		top: "0",
		left: "0",
		bottom: "0",
		right: "0",
	},
	fillSpace: {
		width: "100%",
		height: "100%",
	},
	center: { display: "flex", justifyContent: "center", alignItems: "center" },
	section: {
		w: "100vw",
		h: "100vh",
		maxW: "100vw",
		overflowX: "hidden",
		position: "relative",
	},
	bgImage: {
		w: "100vw",
		h: "100%",
		minW: "100vw",
		position: "absolute",
		zIndex: "-2",
		left: "0",
		top: "0",
		objectFit: "cover",
	},
	overlay: {
		w: "100%",
		h: "100%",
		zIndex: "1",
		position: "absolute",
		top: "0",
		left: "0",
		right: "0",
		bg: "#000000",
		opacity: "0.3",
	},
}
